import { CLIENT_SECRET } from "./endpoint-urls";
import http from "./http-service";

export const getClientSecret = () => {
  return http.get(`${CLIENT_SECRET}`).then((res) => {
    return res.data;
  });
};
